import React from "react";
import { Menu, Select } from "@sscs/ui";
import { SECRET_LIVENESS_SHORT_LABEL } from "../../../constants";
const SecretLivenessFilter = ({ value, className, onChange, ...props }) => {
    var _a;
    return (React.createElement(Select, { id: "secret-liveness-filter", label: "Filter by secret liveness", labelId: "secret-liveness-filter-label", "data-filtered-by-link": (_a = props["data-filtered-by-link"]) !== null && _a !== void 0 ? _a : false, displayEmpty: true, shrinkLabel: true, value: value, onChange: (value) => onChange(value), className: className },
        React.createElement(Menu.Item, { id: "show-all-secrets", value: "ALL" }, "Show all secrets"),
        React.createElement(Menu.Item, { id: "filter-by-active", value: "active" }, SECRET_LIVENESS_SHORT_LABEL.active),
        React.createElement(Menu.Item, { id: "filter-by-inactive", value: "inactive" }, SECRET_LIVENESS_SHORT_LABEL.inactive)));
};
export default SecretLivenessFilter;
//# sourceMappingURL=SecretLivenessFilter.js.map